import { Injectable, inject } from '@angular/core';
import { AuthService } from '../../features/auth/services/auth.service';

export type AccessLevel = 'SysAdmin' | 'TenantAdmin' | 'User' | 'Anonymous';

@Injectable({
  providedIn: 'root',
})
export class AccessContextService {
  private authService = inject(AuthService);

  getAccessLevel(): AccessLevel {
    const token = this.authService.getToken();
    if (!token) {
      return 'Anonymous';
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1] ?? ''));
      const accessLevel = payload['authhub_access_level'];

      if (
        accessLevel === 'SysAdmin' ||
        accessLevel === 'TenantAdmin' ||
        accessLevel === 'User'
      ) {
        return accessLevel;
      }
    } catch {
      // Ignore malformed tokens and fall back to Anonymous.
    }

    return 'Anonymous';
  }

  isSysAdmin(): boolean {
    return this.getAccessLevel() === 'SysAdmin';
  }

  isTenantAdmin(): boolean {
    return this.getAccessLevel() === 'TenantAdmin';
  }

  canManageTenants(): boolean {
    return this.isSysAdmin();
  }

  canViewTenantAdmins(): boolean {
    const accessLevel = this.getAccessLevel();
    return accessLevel === 'SysAdmin' || accessLevel === 'TenantAdmin';
  }

  canManageTenantAdmins(): boolean {
    return this.isSysAdmin();
  }

  canViewUsers(): boolean {
    const accessLevel = this.getAccessLevel();
    return (
      accessLevel === 'SysAdmin' ||
      accessLevel === 'TenantAdmin'
    );
  }

  canManageUsers(): boolean {
    const accessLevel = this.getAccessLevel();
    return accessLevel === 'SysAdmin' || accessLevel === 'TenantAdmin';
  }
}
